import './pagedloader.less'

import {
	Filter,
	FilterMultiple,
	FilterParameterSingle,
	FilterSingle,
	ParameterDecode,
	exportFilters,
	parameterMultiple,
	parameterSingle
} from 'util/filter'
import {Ref, ref} from 'util/ref'
import {View, classes, m} from '@codeurs/front'

import {Fetcher} from 'util/fetcher'
import {PaginationThemed} from 'views/pagination'
import scrollIntoView from 'scroll-into-view-if-needed'

interface PagedResponse<T> {
	current_page: number
	data: Array<T>
	first_page_url: string
	from: number
	last_page: number
	last_page_url: string
	next_page_url: string
	path: string
	per_page: number
	prev_page_url?: string
	to: number
	total: number
}

type PagedFilters = {
	page: FilterSingle<number>
	[key: string]: Filter<any>
}

type ParameterCreator = <T>(
	name: string,
	decode?: ParameterDecode<T>
) => Filter<any>

export const pageParameter = () =>
	new FilterParameterSingle('page', v => (v ? parseInt(v, 10) : 0))

export const pagedFilters = (
	create: (creators: {
		single: ParameterCreator
		multiple: ParameterCreator
	}) => {[key: string]: Filter<any>}
): PagedFilters => {
	const page = pageParameter()
	const filter = <T>(param: Ref<T>): Ref<T> =>
		ref(param, v => (page.ref(0), param(v)))
	return {
		page,
		...create({
			single: (name, decode?) =>
				new FilterSingle(filter(parameterSingle(name, decode))),
			multiple: (name, decode?) =>
				new FilterMultiple(filter(parameterMultiple(name, decode)))
		})
	}
}

export class PagedLoader extends View<{
	url: string
	filters: PagedFilters
	children: any
}> {
	render = this.render

	view() {
		const {children, url, filters} = this.attrs
		return m(Fetcher,
			{
				url,
				data: {
					...exportFilters(filters),
					page: filters.page.ref() + 1
				}
			},
			({isLoading, data}) => {
				const response: PagedResponse<any> = data as any
				const scrollToTop = () => {
					const container = document.querySelector('.pagedloader')
					if (container)
						setTimeout(() => {
							scrollIntoView(container, {block: 'start'})
						}, 250)
				}
				const page = filters.page.ref
				return m('.pagedloader',
					classes({is: {loading: isLoading}}),
					response && children(response),
					response &&
						response.total === 0 &&
						m('.pagedloader-noresult', 'No results found'),
					response &&
						response.last_page > 1 &&
						m(PaginationThemed, {
							current: ref(page, v => {
								page(v)
								scrollToTop()
							}),
							total: response.last_page
						})
				)
			}
		)
	}
}
